$.fn.btnLoader = function () {

    const $elem = $(this);

    const functions = {
        show() {
            $elem.data('html-val', $elem.html());
            $elem.attr('disabled', true);
            $elem.html('<div class="css-loader"></div>');
        },

        hide() {
            $elem.removeAttr('disabled', true);
            $elem.html($elem.data('html-val'));
        },
    };

    return functions;
};
